<!-- Spacer -->
<div
  class="fuse-horizontal-navigation-item-wrapper"
  [ngClass]="$safeNavigationMigration(item.classes?.wrapper)"
></div>
